<template>
  <div class="tags-content-div">
    <div class="tags-content">
      <el-card
        shadow="hover"
        v-for="(item, index) in CaseContractorList"
        :key="index"
        @click.native="caseClick(item.referringSite)"
      >
        <el-row class="solution-case-img"><img :src="item.imageUrl" /></el-row>
        <el-row class="solution-case-text">
          <el-row class="solution-title">{{item.title}}
          </el-row>
          <el-row class="solution-text">{{item.description}}
          </el-row>
        </el-row>
      </el-card>
    </div>
    <div class="page-div">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="pageData2.pageNum"
        :total="pageData2.pageCount"
        :page-size="pageData2.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getSolutionList, getApplication } from '@/api/landing'
import { scrollTopFun } from '@/utils/universalFun.js'
export default {
  name: 'case-contractor',
  created () { },
  mounted () {
    // this.closeVideo()
    this.getSolution()
    // this.computeVideoSize()
  },
  data () {
    return {
      CaseContractorList: [],
      pageData2: {
        pageNum: 1,
        pageCount: 0,
        pageSize: 12,
        solutionId: ''
      },
      solutionList: []
    }
  },
  props: {},
  methods: {
    // 查询解决方案
    getSolution () {
      // 查询解决方案
      getSolutionList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          for (let index = 0; index < data.length; index++) {
            if (data[index].clientGroup === '施工方') {
              this.pageData2.solutionId = data[index].id
            }
          }
          // 查询应用案列
          this.getList()
        } else {
          this.pageData2.solutionId = ''
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.pageData2.solutionId = ''
      })
    },
    // 获取列表
    getList () {
      // 查询应用案列，默认查询第一页
      getApplication(this.pageData2)
        .then(res => {
          const { code, data, message } = res
          if (code === 200) {
            this.CaseContractorList = data.list || []
            this.pageData2.pageCount = data.count
          } else {
            this.CaseContractorList = []
            message && this.$message.error(message)
          }
        })
        .catch(() => {
          this.CaseContractorList = []
        })
    },
    // 查看应用案例
    caseClick (caseUrl) {
      this.sentLog(100102007)
      window.open(caseUrl, '_blank')
    },
    // 切换分页
    handleCurrentChange (val) {
      this.pageData2.pageNum = val
      this.getList()
      this.toTop()
    },
    // 返回首页
    pageOne () {
      this.pageData2.pageNum = 1
      this.getList()
    },
    // 回到顶部
    toTop () {
      scrollTopFun()
    }

  }
}
</script>

<style lang="scss" scoped>
.tags-content-div {
  width: 1250px;
  margin: auto;
}
.tags-content {
  width: 1250px;
  margin: auto;
  display: flex;
  flex-flow: wrap;
  margin-left: 23px;
  // margin-bottom: 56px;
}
.page-div {
  margin: 48px auto 0px auto;
  -webkit-user-select: none; /*谷歌 /Chrome*/
  -moz-user-select: none; /*火狐/Firefox*/
  -ms-user-select: none; /*IE 10+*/
  user-select: none;
  ::v-deep .el-pagination {
    justify-content: center !important;
  }
  ::v-deep .el-pagination__total {
    display: none;
  }
  ::v-deep .el-pager li {
    font-size: 14px;
    font-weight: 400;
    color: rgba(31, 31, 31, 0.8);
    border: 1px solid #dedede;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #ffffff;
    border: 1px solid #4499ff;
    color: #4499ff;
  }
  ::v-deep .el-pagination.is-background .btn-prev {
    border: 1px solid #dedede;
  }
  ::v-deep .el-pagination.is-background .btn-next {
    border: 1px solid #dedede;
  }
}
::v-deep  .el-card {
  width: 384px;
  height: 356px;
  background: #ffffff;
  margin-top: 23px;
  margin-right: 23px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
  // box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  border:0px;
  .el-card__body {
    padding: 0px;
  }
}
::v-deep  .el-card:hover {
  box-shadow: 0px 7px 9px 0px rgba(0, 0, 0, 0.16);
  cursor: pointer;
}
::v-deep .el-rol {
  width: auto;
}
::v-deep .el-col-24 {
  width: auto;
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.solution-case-title {
  height: 56px;
  font-size: 40px;
  // font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #181f42;
  line-height: 56px;
  text-align: center;
  margin-top: 78px;
  margin-bottom: 44px;
}
.solution-case-img {
  // width: 582px;
  height: 202px;
  background: #e3e3e3;
  border-radius: 6px 6px 0px 0px;
  img {
    // width: 582px;
    // height: 231px;
    width: 384px;
    height: 202px;
  }
}
.solution-case-text {
  ::v-deep  .el-row {
    text-align: center;
  }
  .solution-title {
    // width: 336px;
    // margin: 26px auto 11px auto !important;
    // height: 44px;
    min-height: 44px;
    font-size: 16px;
    text-align: left;
    // font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #181f42;
    line-height: 22px;
    margin-top: 22px;
    margin-bottom: 14px;
    padding-left: 23px;
    padding-right: 25px;
    //控制显示文字的行数
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .solution-title:hover {
    color: #4499ff;
    cursor: pointer;
  }
  .solution-text {
    margin: auto !important;
    min-height: 44px;
    font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5c5c65;
    line-height: 22px;
    padding-left: 23px;
    padding-right: 16px;
    text-align: left;
    //控制显示文字的行数
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .solution-btn {
    margin-top: 23px;
    ::v-deep  .el-button {
      line-height: 0;
      width: 110px;
      height: 33px;
      border-radius: 4px;
      border: 1px solid #4499ff;
      color: #4499ff;
      font-size: 14px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    ::v-deep  .el-button:hover {
      background: #4499ff;
      color: #ffffff;
    }
  }
}
</style>
